import React from 'react'

const SvgTShirtOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.134 6.029a2.613 2.613 0 00-1.778 1.095l-2.043 2.98L6 11.671V10.25h2V17a1 1 0 001 1h6a1 1 0 001-1v-6.75h2v1.421l1.688-1.567-2.044-2.98a2.613 2.613 0 00-1.777-1.095 4.002 4.002 0 01-7.733 0zM10.268 6a2 2 0 003.464 0h-3.464zM18 14.366a1 1 0 00.18-.133l3.5-3.25a1 1 0 00.145-1.299l-2.531-3.691A4.629 4.629 0 0015.474 4H8.526a4.628 4.628 0 00-3.82 1.993L2.175 9.684a1 1 0 00.145 1.299l3.5 3.25c.055.051.116.096.18.133V17a3 3 0 003 3h6a3 3 0 003-3v-2.634z'
    />
  </svg>
)

export default SvgTShirtOutline
